<template>
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6668 2.41406L3.3335 11.7474" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.33317 5.07552C5.25364 5.07552 5.99984 4.32933 5.99984 3.40885C5.99984 2.48838 5.25364 1.74219 4.33317 1.74219C3.4127 1.74219 2.6665 2.48838 2.6665 3.40885C2.6665 4.32933 3.4127 5.07552 4.33317 5.07552Z" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.6667 12.4115C12.5871 12.4115 13.3333 11.6653 13.3333 10.7448C13.3333 9.82432 12.5871 9.07812 11.6667 9.07812C10.7462 9.07812 10 9.82432 10 10.7448C10 11.6653 10.7462 12.4115 11.6667 12.4115Z" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#717680',
    },
  },
};
</script>

